(function() {
  var dataEl = document.querySelector('[data-portfolio-blocks]');
  var SECTION_ID = dataEl ? dataEl.dataset.sectionId : '';

  /* --- Badge class map --- */
  var BADGE_CLASSES = {
    'tv-mounting': 'portfolio-grid__badge--tv-mounting',
    'wifi-networking': 'portfolio-grid__badge--wifi-networking',
    'security-cameras': 'portfolio-grid__badge--security-cameras',
    'smart-home': 'portfolio-grid__badge--smart-home',
    'it-support': 'portfolio-grid__badge--it-support',
    'home-theater': 'portfolio-grid__badge--home-theater'
  };

  var BADGE_LABELS = {
    'tv-mounting': 'TV Mounting',
    'wifi-networking': 'WiFi & Networking',
    'security-cameras': 'Security Cameras',
    'smart-home': 'Smart Home',
    'it-support': 'IT Support',
    'home-theater': 'Home Theater'
  };

  /* Allowed embed domains for video URLs */
  var ALLOWED_VIDEO_HOSTS = ['www.youtube-nocookie.com', 'player.vimeo.com'];

  /* --- Parse block data --- */
  var blocks = [];
  if (dataEl) {
    try { blocks = JSON.parse(dataEl.textContent); } catch(e) { /* noop */ }
  }

  /* --- Filter logic --- */
  var filterBtns = document.querySelectorAll('.portfolio-grid__filter-btn');
  var cards = document.querySelectorAll('.portfolio-grid__card');
  var noResults = document.querySelector('.portfolio-grid__no-results');

  filterBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var filter = btn.getAttribute('data-filter');

      /* Update pressed state */
      filterBtns.forEach(function(b) { b.setAttribute('aria-pressed', 'false'); });
      btn.setAttribute('aria-pressed', 'true');

      var visibleCount = 0;
      cards.forEach(function(card) {
        if (filter === 'all' || card.getAttribute('data-service-type') === filter) {
          card.removeAttribute('hidden');
          visibleCount++;
        } else {
          card.setAttribute('hidden', '');
        }
      });

      /* Show/hide no-results message */
      if (noResults) {
        if (visibleCount === 0) {
          noResults.classList.add('is-visible');
        } else {
          noResults.classList.remove('is-visible');
        }
      }
    });
  });

  /* --- Modal logic --- */
  var overlay = document.getElementById('portfolio-modal-' + SECTION_ID);
  if (!overlay) return;

  var galleryTrack = overlay.querySelector('[data-gallery-track]');
  var prevBtn = overlay.querySelector('[data-gallery-prev]');
  var nextBtn = overlay.querySelector('[data-gallery-next]');
  var counter = overlay.querySelector('[data-gallery-counter]');
  var modalTitle = overlay.querySelector('[data-modal-title]');
  var modalBadge = overlay.querySelector('[data-modal-badge]');
  var modalLocation = overlay.querySelector('[data-modal-location]');
  var modalLocationText = overlay.querySelector('[data-modal-location-text]');
  var modalDesc = overlay.querySelector('[data-modal-desc]');

  var currentSlide = 0;
  var totalSlides = 0;
  var previouslyFocused = null;

  /* Helper: convert YouTube/Vimeo URL to embeddable */
  function getEmbedUrl(url) {
    if (!url) return null;
    /* YouTube */
    var ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]+)/);
    if (ytMatch) return 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(ytMatch[1]) + '?rel=0';
    /* Vimeo */
    var vmMatch = url.match(/vimeo\.com\/(\d+)/);
    if (vmMatch) return 'https://player.vimeo.com/video/' + encodeURIComponent(vmMatch[1]) + '?dnt=1';
    return null;
  }

  /* Helper: validate embed URL against allowed hosts */
  function isAllowedEmbedUrl(url) {
    try {
      var parsed = new URL(url);
      return ALLOWED_VIDEO_HOSTS.indexOf(parsed.hostname) !== -1;
    } catch(e) {
      return false;
    }
  }

  /* Helper: create a gallery image slide */
  function createImageSlide(src, altText) {
    var div = document.createElement('div');
    div.className = 'portfolio-grid__gallery-item';
    var img = document.createElement('img');
    img.src = src;
    img.alt = altText;
    img.loading = 'lazy';
    div.appendChild(img);
    return div;
  }

  /* Helper: create a gallery video slide */
  function createVideoSlide(embedUrl, titleText) {
    var div = document.createElement('div');
    div.className = 'portfolio-grid__gallery-item';
    var iframe = document.createElement('iframe');
    iframe.src = embedUrl;
    iframe.title = 'Video: ' + titleText;
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    div.appendChild(iframe);
    return div;
  }

  /* Helper: create placeholder slide when no media */
  function createPlaceholderSlide() {
    var div = document.createElement('div');
    div.className = 'portfolio-grid__gallery-item';
    var placeholder = document.createElement('div');
    placeholder.className = 'portfolio-grid__card-placeholder';
    placeholder.setAttribute('aria-hidden', 'true');
    var svgNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.5');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.style.width = '6rem';
    svg.style.height = '6rem';
    svg.style.color = 'rgba(255,255,255,0.3)';
    var rect = document.createElementNS(svgNS, 'rect');
    rect.setAttribute('x', '3'); rect.setAttribute('y', '3');
    rect.setAttribute('width', '18'); rect.setAttribute('height', '18');
    rect.setAttribute('rx', '2'); rect.setAttribute('ry', '2');
    var circle = document.createElementNS(svgNS, 'circle');
    circle.setAttribute('cx', '8.5'); circle.setAttribute('cy', '8.5');
    circle.setAttribute('r', '1.5');
    var polyline = document.createElementNS(svgNS, 'polyline');
    polyline.setAttribute('points', '21 15 16 10 5 21');
    svg.appendChild(rect);
    svg.appendChild(circle);
    svg.appendChild(polyline);
    placeholder.appendChild(svg);
    div.appendChild(placeholder);
    return div;
  }

  function buildGallery(data) {
    /* Clear existing children safely */
    while (galleryTrack.firstChild) {
      galleryTrack.removeChild(galleryTrack.firstChild);
    }
    var items = [];
    var altText = data.title || 'Project photo';

    /* Images */
    if (data.images && data.images.length > 0) {
      data.images.forEach(function(src) {
        if (src) {
          items.push(createImageSlide(src, altText));
        }
      });
    }

    /* Video */
    var embedUrl = getEmbedUrl(data.videoUrl);
    if (embedUrl && isAllowedEmbedUrl(embedUrl)) {
      items.push(createVideoSlide(embedUrl, data.title || 'Project video'));
    }

    /* Placeholder if no media */
    if (items.length === 0) {
      items.push(createPlaceholderSlide());
    }

    items.forEach(function(el) { galleryTrack.appendChild(el); });
    totalSlides = items.length;
    currentSlide = 0;
    showSlide(0);

    /* Show/hide nav */
    var showNav = totalSlides > 1;
    prevBtn.style.display = showNav ? '' : 'none';
    nextBtn.style.display = showNav ? '' : 'none';
    counter.style.display = showNav ? '' : 'none';
  }

  function showSlide(idx) {
    var items = galleryTrack.querySelectorAll('.portfolio-grid__gallery-item');
    items.forEach(function(el) { el.classList.remove('is-active'); });
    if (items[idx]) items[idx].classList.add('is-active');
    currentSlide = idx;
    if (counter && totalSlides > 1) {
      counter.textContent = (idx + 1) + ' / ' + totalSlides;
    }
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      showSlide((currentSlide - 1 + totalSlides) % totalSlides);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      showSlide((currentSlide + 1) % totalSlides);
    });
  }

  function openModal(index) {
    var data = blocks[index];
    if (!data) return;

    previouslyFocused = document.activeElement;

    /* Populate using textContent (safe) */
    if (modalTitle) modalTitle.textContent = data.title || '';
    if (modalDesc) modalDesc.textContent = data.description || '';
    if (modalLocationText) modalLocationText.textContent = data.location || '';
    if (modalLocation) modalLocation.style.display = data.location ? '' : 'none';

    /* Badge */
    if (modalBadge) {
      modalBadge.textContent = BADGE_LABELS[data.serviceType] || '';
      modalBadge.className = 'portfolio-grid__modal-badge ' + (BADGE_CLASSES[data.serviceType] || '');
    }

    /* Gallery */
    buildGallery(data);

    /* Show */
    overlay.classList.add('is-open');
    document.body.classList.add('portfolio-modal-open');

    /* Focus close button */
    var closeBtn = overlay.querySelector('.portfolio-grid__modal-close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    overlay.classList.remove('is-open');
    document.body.classList.remove('portfolio-modal-open');

    /* Clean up iframes */
    var iframes = galleryTrack.querySelectorAll('iframe');
    iframes.forEach(function(iframe) { iframe.removeAttribute('src'); });

    /* Restore focus */
    if (previouslyFocused) {
      previouslyFocused.focus();
      previouslyFocused = null;
    }
  }

  /* Open on card click / Enter / Space */
  cards.forEach(function(card) {
    card.addEventListener('click', function() {
      var idx = parseInt(card.getAttribute('data-card-index'), 10);
      openModal(idx);
    });
    card.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        var idx = parseInt(card.getAttribute('data-card-index'), 10);
        openModal(idx);
      }
    });
  });

  /* Close handlers */
  overlay.querySelectorAll('[data-portfolio-close]').forEach(function(el) {
    el.addEventListener('click', closeModal);
  });

  /* Escape key */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
      closeModal();
    }
  });

  /* Focus trap */
  overlay.addEventListener('keydown', function(e) {
    if (e.key !== 'Tab') return;
    if (!overlay.classList.contains('is-open')) return;

    var focusable = overlay.querySelectorAll(
      'button:not([disabled]):not([hidden]), a[href]:not([hidden]), [tabindex]:not([tabindex="-1"]):not([hidden])'
    );
    if (focusable.length === 0) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

})();
